import React from 'react'
import {
  SafetyQualityRoot,
  SectionWrapper,
  Header,
  Description,
  BadgeWrapper,
  BorderWrapper,
} from './SafetyQuality.styles'
import useTranslation from 'next-translate/useTranslation'
import Image from 'next/image'
import { BorderWave } from 'components/BorderWave'
import badge from '../../../../../../../../public/assets/recipes/categories/meet-our-meats-badge.webp'

export const SafetyQuality: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <BorderWrapper>
        <BorderWave
          background="accent-white"
          svgHeight="78px"
          invert
          svgWidth="calc(144% + 1.3px)"
          path="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
        />
        <BadgeWrapper>
          <Image src={badge} alt="" />
        </BadgeWrapper>
      </BorderWrapper>
      <SafetyQualityRoot>
        <SectionWrapper>
          <Header>{t('products:safetyQuality.safety.title')}</Header>
          <Description>{t('products:safetyQuality.safety.description')}</Description>
        </SectionWrapper>
        <SectionWrapper>
          <Header>{t('products:safetyQuality.quality.title')}</Header>
          <Description>{t('products:safetyQuality.quality.description')}</Description>
        </SectionWrapper>
      </SafetyQualityRoot>
    </>
  )
}
